module.exports = __webpack_public_path__ + "static/media/inbox-emoji.d82348fa.png";